;(() => {
    if (customElements.get('hoculus-cross-sell')) return;

    class HoculusCrossSell extends HTMLElement {
        constructor() {
            super();
        }
    
        connectedCallback() {
            document.addEventListener('ajaxProduct:added', () => {
                this.handleAddedToCart();
            });
        }
    
        async handleAddedToCart() {
            const text = await this.getSwiperSlidesMarkup();
    
            if (!text.trim()) return;
    
            this.innerHTML = "";
            this.insertAdjacentHTML('beforeend', text);
        }
    
        async getSwiperSlidesMarkup() {
            let url = ''.concat(theme.routes.cartPage, '?t=').concat(Date.now());
        
            url = url.indexOf('?') === -1 ? (url + '?view=cross_sell_slider') : (url + '&view=cross_sell_slider');
        
            try {
                const response = await fetch(url, {
                    credentials: 'same-origin',
                    method: 'GET'
                })
    
                if (!response.ok) throw new Error('Failed to fetch cross sell slider html');
    
                const text = await response.text();
    
                return text;
            } catch (error) {
                console.error('Error:', error);
            }
          }
    }

    customElements.define('hoculus-cross-sell', HoculusCrossSell);
})();